import { types as cvcTypes } from "./cvc.actions";
import { types as formTypes } from "./../form.actions";
import { validate } from "./cvc.domain";

export const defaultState = {
  value: null,
  valid: false,
  pristine: true,
};

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case cvcTypes.INPUT:
      return {
        value: action.value,
        valid: validate(action.value),
        pristine: false,
      };
    case formTypes.CLEAR:
      return {
        value: action.card ? action.card.cvc : defaultState.value,
        valid: !!action.card,
        pristine: true,
      };
    default:
      return state;
  }
};
